import React, {useEffect, useState} from 'react';
import {Checkbox, Col, Form, Input, Modal, Row, Select, Switch, Divider} from "antd";
const { Option } = Select;

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
};

const tailItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
};

const checkboxItemLayout = {
    wrapperCol: { offset: 6, span: 16 },
};

const brokerConfigs = {
    'BKS': {
        fields: [
            {
                name: 'autoLoad',
                label: 'Автозагрузка отчетов',
                type: 'checkbox',
                valuePropName: 'checked'
            },
            {
                name: 'reportAccountNumber',
                label: 'Номер счета:',
                type: 'text',
                rules: [{ required: true, message: 'Введите номер счета' }]
            }
        ]
    },
    'TINKOFF': {
        fields: [
            {
                name: 'apiToken',
                label: 'API Токен',
                type: 'password', // Используем password для безопасности
                rules: [{ required: true, message: 'Введите API токен' }],
                secure: true // Помечаем как безопасное поле
            },
            {
                name: 'accountId',
                label: 'ID Счета',
                type: 'text',
                rules: [{ required: true, message: 'Введите ID счета' }]
            }
        ]
    }
    // Можно добавить конфигурации для других брокеров
};

const AssetDialog = ({  visible = false, data = {},
                        dialogHandler = () => {}, assetTypes = [],
                        brokers = []
                     }) => {
    const {id, name, assetType, isActive, broker,
        isTested, isTrading=false,
        reportLoaderParams = {}
    } = data;
    const [form] = Form.useForm();
    const [currentAssetType, setCurrentAssetType] = useState({});
    const [selectedBroker, setSelectedBroker] = useState(null);

    // Безопасное отображение токена (показываем только первые и последние 4 символа)
    const maskToken = (token) => {
        if (!token || token.length < 8) return '••••';
        return `${token.substring(0, 4)}••••${token.substring(token.length - 4)}`;
    };

    // Преобразуем данные для формы
    const transformParamsForForm = (brokerId, params = {}) => {
        const config = brokerConfigs[brokerId];
        if (!config) return {};

        const formData = {};

        config.fields.forEach(field => {
            formData[field.name] = params[field.name];
        });

        return formData;
    };

    useEffect(() => {
        const initAssetType = assetType ?
            assetTypes.filter(value => value.id === assetType).at(0)
            : assetTypes.length > 0 ? assetTypes[0] : {};

        const currentBroker = broker?.id || '';
        setCurrentAssetType(initAssetType);
        setSelectedBroker(currentBroker);

        const brokerParams = transformParamsForForm(currentBroker, reportLoaderParams);

        form.setFieldsValue({
            name,
            assetType: initAssetType,
            isActive,
            isTested,
            broker,
            isTrading,
            ...brokerParams
        });
    }, [data, assetTypes, form]);


    const onOk = () => {
        form.validateFields().then(values => {
            const currentBroker = values.broker?.id;
            const config = brokerConfigs[currentBroker];

            // Собираем reportLoaderParams только с полями из конфигурации
            const reportLoaderParams = {};
            if (config) {
                config.fields.forEach(field => {
                    reportLoaderParams[field.name] = values[field.name];
                });
            }

            const result = {
                ...data,
                ...values,
                assetType: values.assetType.id,
                reportLoaderParams
            };
            dialogHandler(true, result)
        });
    }

    const handleBrokerChange = (brokerId) => {
        setSelectedBroker(brokerId);
        // Очищаем поля reportLoaderParams при смене брокера
        const config = brokerConfigs[brokerId];
        if (config) {
            const clearValues = {};
            config.fields.forEach(field => {
                clearValues[field.name] = undefined;
            });
            form.setFieldsValue(clearValues);
        }
    };

    const renderBrokerFields = () => {
        const config = brokerConfigs[selectedBroker];
        if (!config) return null;

        return config.fields.map((field, index) => {
            const commonProps = {
                key: field.name,
                label: field.label,
                name: field.name,
                ...tailItemLayout
            };

            switch (field.type) {
                case 'checkbox':
                    return (
                        <Form.Item
                            key={field.name}
                            name={field.name}
                            valuePropName={field.valuePropName}
                            {...checkboxItemLayout} // Используем layout без label
                        >
                            <Checkbox disabled={field.disabled}>
                                {field.label} {/* Текст остается внутри checkbox */}
                            </Checkbox>
                        </Form.Item>
                    );

                case 'password':
                    return (
                        <Form.Item
                            {...commonProps}
                            rules={field.rules}
                        >
                            <Input.Password
                                placeholder={`Введите ${field.label.toLowerCase()}`}
                                disabled={field.disabled}
                                visibilityToggle={true}
                            />
                        </Form.Item>
                    );

                case 'text':
                default:
                    return (
                        <Form.Item
                            {...commonProps}
                            rules={field.rules}
                        >
                            <Input
                                placeholder={`Введите ${field.label.toLowerCase()}`}
                                disabled={field.disabled}
                                type={field.type}
                            />
                        </Form.Item>
                    );
            }
        });
    };

    const brokerFields = () => {
        const {id: idAssetType} = currentAssetType;
        if( idAssetType === 'STOCK_EXCHANGE' ) {
            return(
                <>
                    <Form.Item
                        label="Брокер"
                        {...tailItemLayout}
                        name={['broker','id']}
                    >
                        <Select
                            placeholder="Выберите брокера"
                            onChange={handleBrokerChange}
                            disabled={!!id}
                        >
                            {brokers.map( broker => <Option key={broker.id} value={broker.id}>{broker.name}</Option> )}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        // label="Настройки"
                        {...checkboxItemLayout}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    name='isTrading'
                                    valuePropName='checked'
                                    noStyle
                                >
                                    <Checkbox>Автоматическая торговля</Checkbox>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    name='isTested'
                                    valuePropName='checked'
                                    noStyle
                                >
                                    <Checkbox disabled={!!id}>Тестовый</Checkbox>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form.Item>

                    {/* Динамические поля брокера */}
                    {selectedBroker && (
                        <div style={{ marginTop: '16px' }}>
                            <Divider orientation="center">Настройки брокера</Divider>
                            {renderBrokerFields()}
                        </div>
                    )}
                </>
            )
        }
    }


    return (
        <Modal
            title= {id ? 'Редактирование актива': 'Новый актив'}
            className="uk-panel-title"
            open={visible}
            onCancel={() => dialogHandler(false)}
            onOk={onOk}
            width={600}
        >
            <Form
                form={form}
                layout="horizontal"
                labelAlign="left"
            >
                <Form.Item
                    label="Наименование"
                    {...tailItemLayout}
                    name='name'
                    rules={[{required: true, message: 'Пожалуйста, введите наименование.'}]}
                >
                    <Input placeholder="Введите наименование" />
                </Form.Item>

                <Form.Item
                    label="Тип актива"
                    {...tailItemLayout}
                    name={['assetType','id']}
                    rules={[{required: true, message: 'Пожалуйста, определите тип актива'}]}
                >
                    <Select
                        disabled={!!id}
                        onChange={(id)=> setCurrentAssetType({id})}
                        placeholder="Выберите тип актива"
                    >
                        {assetTypes.map( type => (
                            <Option key={type.id} value={type.id}>{type.name}</Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    {...checkboxItemLayout}
                    name='isActive'
                    valuePropName='checked'
                >
                    <Checkbox>Активный</Checkbox>
                </Form.Item>

                {brokerFields()}
            </Form>
        </Modal>
    );

}

export default AssetDialog;
